import React, { useState, useEffect } from 'react';
import { FaPlus, FaSearch, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const StatusProcesso = () => {
  const [statusProcessos, setStatusProcessos] = useState([]);
  const [filteredStatusProcessos, setFilteredStatusProcessos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    status_processo: '',
    ativo: true
  });

  useEffect(() => {
    const carregarStatus = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/status-processo`
        );

        if (!response.ok) {
          throw new Error('Erro ao buscar status de processo');
        }

        const data = await response.json();
        setStatusProcessos(data);
        setFilteredStatusProcessos(data);
      } catch (error) {
        console.error('Erro ao carregar status de processo:', error);
        alert(
          'Erro ao carregar status de processo. Verifique a conexão com o servidor.'
        );
      }
    };

    carregarStatus();
  }, []);

  useEffect(() => {
    const termo = searchTerm.toLowerCase();
    const filtrados = statusProcessos.filter((status) =>
      status.status_processo.toLowerCase().includes(termo)
    );
    setFilteredStatusProcessos(filtrados);
  }, [searchTerm, statusProcessos]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      status_processo: formData.status_processo,
      ativo: formData.ativo
    };

    try {
      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/status-processo/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar status de processo');
        }
      } else {
        const response = await fetch(
          `${API_BASE_URL}/status-processo`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar status de processo');
        }
      }

      const listaAtualizada = await (
        await fetch(`${API_BASE_URL}/status-processo`)
      ).json();

      setStatusProcessos(listaAtualizada);
      setFilteredStatusProcessos(listaAtualizada);
      resetForm();
    } catch (error) {
      console.error('Erro ao salvar status de processo:', error);
      alert(
        'Erro ao salvar status de processo. Verifique os dados e tente novamente.'
      );
    }
  };

  const handleEdit = (status) => {
    setFormData({
      status_processo: status.status_processo,
      ativo: status.ativo
    });
    setEditingId(status.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        'Tem certeza que deseja excluir este status de processo?'
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/status-processo/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir status de processo');
      }

      const listaAtualizada = await (
        await fetch(`${API_BASE_URL}/status-processo`)
      ).json();

      setStatusProcessos(listaAtualizada);
      setFilteredStatusProcessos(listaAtualizada);
    } catch (error) {
      console.error('Erro ao excluir status de processo:', error);
      alert(
        'Erro ao excluir status de processo. Tente novamente mais tarde.'
      );
    }
  };

  const resetForm = () => {
    setFormData({ status_processo: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (status) => {
    const novoStatus = !status.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/status-processo/${status.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            status_processo: status.status_processo,
            ativo: novoStatus
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status');
      }

      setStatusProcessos((prev) =>
        prev.map((item) =>
          item.id === status.id ? { ...item, ativo: novoStatus } : item
        )
      );
      
      // Update filtered list as well to reflect change immediately
      setFilteredStatusProcessos((prev) =>
        prev.map((item) =>
          item.id === status.id ? { ...item, ativo: novoStatus } : item
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do processo:', error);
      alert(
        'Erro ao atualizar status do processo. Tente novamente.'
      );
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Status de Processo</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <FaPlus />
            Cadastrar Status
          </button>
        )}
      </div>

      <div className="table-controls">
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Pesquisar status de processos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="table-info">
          <span>{filteredStatusProcessos.length} registro(s) encontrado(s)</span>
        </div>
      </div>

      {showForm && (
        <div className="inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Status de Processo' : 'Cadastrar Status de Processo'}</h2>
            <button className="btn-close" onClick={resetForm}>
              <FaTimes />
            </button>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="status_processo">Status do Processo *</label>
              <textarea
                id="status_processo"
                value={formData.status_processo}
                onChange={(e) => setFormData({...formData, status_processo: e.target.value})}
                required
                rows={3}
                placeholder="Digite o status do processo"
              />
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
                />
                Ativo
              </label>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary">
                <FaSave /> {editingId ? 'Atualizar' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      )}

      {!showForm && (
        <div className="table-container">
          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Status do Processo</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredStatusProcessos.map((status) => (
                  <tr key={status.id}>
                    <td className="col-id">{status.id}</td>
                    <td className="col-nome">{status.status_processo}</td>
                    <td className="col-status">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={status.ativo}
                          onChange={() => handleToggleStatus(status)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(status)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(status.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredStatusProcessos.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch />
                </div>
                <h3>Nenhum status de processo encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo status.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusProcesso;
